import React from "react";
import ReactApexChart from "react-apexcharts";

const DonutChart = ({ 
  providers, 
  totalEncounters, 
  signedEncounters, 
  unsignedEncounters, 
  nonduplicatePatcount, 
  CPTCount, 
  UnitCount 
}) => {
  
  const seriesData = [
    totalEncounters.reduce((sum, count) => sum + count, 0),
    signedEncounters.reduce((sum, count) => sum + count, 0),
    unsignedEncounters.reduce((sum, count) => sum + count, 0),
    nonduplicatePatcount.reduce((sum, count) => sum + count, 0),
    CPTCount.reduce((sum, count) => sum + count, 0),
    UnitCount.reduce((sum, count) => sum + count, 0),
  ];

  const chartData = {
    series: seriesData,
    options: {
      chart: {
        width: 380,
        type: "donut",
      },
      labels: [
        "Total Encounters",
        "Signed Encounters",
        "Unsigned Encounters",
        "Total Patients",
        "Total CPTs",
        "Total Units",
      ],
      plotOptions: {
        pie: {
          startAngle: -90,
          endAngle: 270,
          donut: {
            labels: {
              show: true,
              name: {
                show: true,
                offsetY: 5,
              },
            },
          },
        },
      },
      dataLabels: {
        enabled: true,
        formatter: (val, opts) => `${opts.w.globals.series[opts.seriesIndex]}`,
      },
      fill: {
        type: "gradient",
      },
      legend: {
        position: "right",
        formatter: function (val, opts) {
          return `${val}: ${opts.w.globals.series[opts.seriesIndex]}`;
        },
      },
      title: {
        text: "Provider Data Overview",
        align: "center",
      },
      yaxis: {
        min: 0,
        max: 50,
        tickAmount: 5,
      },
      responsive: [
        {
          breakpoint: 480,
          options: {
            chart: {
              width: 250,
            },
            legend: {
              position: "bottom",
            },
          },
        },
      ],
    },
  };

  return (
    <div>
      <div id="chart" style={{ marginLeft: "350px", marginTop: '80px' }}>
        <ReactApexChart options={chartData.options} series={chartData.series} type="donut" width={880} />
      </div>
    </div>
  );
};

export default DonutChart;
